// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-selector[data-v-e479ed8a]{width:70px;height:70px;border:2px solid #fff;cursor:pointer}@media(min-width:992px){.color-selector[data-v-e479ed8a]{width:77px;height:77px}}.color-selector span[data-v-e479ed8a]{font-size:30px}.text-black[data-v-e479ed8a]{color:#000}", ""]);
// Exports
module.exports = exports;
